var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-month-page"},[_c('calendar',{attrs:{"tasks":_vm.tasks,"holidays":_vm.holidays}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }